import { appName } from '../config'

/**
 * Constants
 * */

export const moduleName = 'menu'
const prefix = `${appName}/${moduleName}`
export const TOGGLE_MENU = `${prefix}/TOGGLE_MENU`

/**
 * Reducer
 * */

const initialState = {
  isOpen: false
};

export const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_MENU:
      return { ...state, isOpen: !state.isOpen};
    default:
      return state;
  }
};

/**
 * Action Creators
 * */

export const toggleMenu = () => {
  return {
    type: TOGGLE_MENU
  }
}


// WEBPACK FOOTER //
// ./src/ducks/menu.js